<template>
  <div>
    <div v-if="!autoImport" class="formatted-reference">
      <router-link :to="{name: 'Root'}" class="btn" style="padding:10px 5px 10px 0;">
        <i class="material-icons">arrow_back</i>
        <span>Start again</span>
      </router-link>
      <div v-if="formattedReference" style="border-radius:2px; padding:20px;" ref="formattedReference">
        <div style="font-size:22px; margin-bottom:20px; text-align:center;">Ta-da! Here's your {{config.sources.find(c => c.id === formattedReference.sourceId).name}} in {{styles.find(s => s.id === $route.params.styleId).name}} style:</div>
        <div style="background:#fef1c4; margin-bottom:10px; padding:20px;">
          <p v-html="formattedReference.formattedReferenceStr" :style="`font-family:Calibri; font-size:18px; margin:0;${formattedReference.hasHangingIndent ? 'margin-left:0.5in; text-indent: -0.5in;' : ''} line-height:${formattedReference.lineSpacing < 2 ? 1.5 : formattedReference.lineSpacing}em;`" ref="formattedReferenceStr"></p>
        </div>
        <div style="margin:0 0 20px 20px; opacity:0.8;">In-text citation: <span v-html="formattedReference.formattedInTextCitationStr"></span></div>
        <div style="display:flex; justify-content:center; ">
          <CopyBtn @click="copyToClipboard(formattedReference.formattedReferenceStr)" />
          <button @click="saveToProject(formattedReference)" :disabled="isImporting" class="btn btn-raised bg-orange white" style="margin-left:10px;">
            <span>
              <i class="material-icons">add</i>
              <span>Edit / Save to project</span>
            </span>
          </button>
        </div>

        <TooltipLg tooltipId="formattedReference" category="intro" placement="left start" :target="formattedReferenceTooltipTarget" primary>
          <p><strong>🎉 Here's your fully formatted reference and in-text citation.</strong></p>
          <p>Copy them straight to your document or save them to your project on MyBib.</p>
        </TooltipLg>
      </div>
      <div v-else style="align-items:center; background:#fef1c4; border-radius:2px; display:flex; justify-content:center; padding:20px;">
        <div style="font-size:80px;">☹️</div>
        <div style="font-size:22px; margin-left:20px; text-align:center;">Oh snap! Something went wrong and we couldn't create your citation, please try again.</div>
      </div>
    </div>
    <div v-else style="height:470px; position:relative;">
      <Spinner />
    </div>
  </div>
</template>

<script>
import CopyBtn from '@/components/CopyBtn';
import TooltipLg from '@/components/TooltipLg';
import Spinner from '@/components/Spinner';

import config from '@/config.js';
import MessageBus from '@/services/messageBus.js';
import copyHtmlToClipboard from '@/utils/copyHtmlToClipboard.js';
import { styles } from '@/utils/styles.js';
import ImportApi from '@/services/importApi.js';

export default {
  name: 'FormattedReference',
  components: {
    CopyBtn,
    TooltipLg,
    Spinner
  },
  props: ['autoImport'],
  data () {
    return {
      formattedReference: null,
      config: config,
      styles: styles,
      isImporting: false,
      formattedReferenceTooltipTarget: null
    }
  },
  methods: {
    copyToClipboard () {
      copyHtmlToClipboard(this.$refs.formattedReferenceStr.outerHTML);
    },
    async saveToProject () {
      this.isImporting = true;
      // first stash the reference in the import API
      const stashId = await ImportApi.stashReference(this.formattedReference);
      // then main app import screen
      const form = document.createElement('form');
      form.setAttribute('method', 'post');
      form.setAttribute('action', `/i/${stashId}?style=${this.$route.params.styleId}`);
      document.body.appendChild(form);
      form.submit();

      this.isImporting = false;
    }
  },
  async created () {
    this.formattedReference = MessageBus.formattedReference;
    this.formattedReference.formattedReferenceStr = this.formattedReference.formattedReferenceStr.replace(/\s*<div class="csl-block">\s*(.+)<\/div>/g, `<br>$1`);
  },
  mounted () {
    this.formattedReferenceTooltipTarget = this.$refs.formattedReference;
    // if the top of the widget is above the viewable window then scroll back to it
    if (this.$root.$el.getBoundingClientRect().top < 0) {
      this.$root.$el.scrollIntoView({behavior: 'smooth'});
    }
  }
}
</script>

<style lang="scss">
  .csl-left-margin { display:inline; margin-right:0.5in; }
  .csl-right-inline { display:inline; }
</style>



// WEBPACK FOOTER //
// src/components/FormattedReference.vue